<ng-container *transloco="let t; read: 'ime.manufacturing.integrated-master-editor'">
  <div class="modal-header" ngxModalDraggable>
    <h4 class="modal-title pull-left me-auto">{{masterInstruction.Code}}</h4>
    <div class="ms-auto d-flex gap-2">
      <ng-container *ngIf="!readonly">
        <button type="button" class="btn btn-outline-danger" (click)="delete()">{{t('Delete')}}</button>
        <button type="button" class="btn btn-outline-primary" (click)="submit()">{{t('Change')}}</button>
      </ng-container>
      <button type="button" class="btn-close pull-right my-auto" aria-label="Close" (click)="close()"></button>
    </div>
  </div>
  <div class="modal-body">
    <form>
      <div class="card">
        <div class="card-body">
          <div class="row">
            <div class="col-lg-6">
              <div class="form-group row">
                <label for="code" class="col-sm-4 col-form-label">{{t('Code')}}</label>
                <div class="col-sm-8">
                  <input type="text" class="form-control" id="code" name="code" [(ngModel)]="masterInstruction.Code" [readonly]="readonly" autocomplete="off">
                </div>
              </div>
              <div class="form-group row">
                <label for="code" class="col-sm-4 col-form-label">{{t('Source code')}}</label>
                <div class="col-sm-8">
                  <input type="text" class="form-control" id="source-code" name="source-code" [(ngModel)]="masterInstruction.SourceCode" [readonly]="readonly" autocomplete="off">
                </div>
              </div>
              <div class="form-group row">
                <label for="code" class="col-sm-4 col-form-label">{{t('Item group')}}</label>
                <div class="col-sm-8">
                  <mes-web-manufacturing-item-group-select name="item-group"
                                                           [entityId]="masterInstruction.ItemGroupId"
                                                           [items$]="itemGroupService.getAll$"
                                                           (entityIdChange)="masterInstruction.ItemGroupId = $event"/>
                </div>
              </div>
              <div class="form-group row">
                <label for="code" class="col-sm-4 col-form-label">{{t('Item')}}</label>
                <div class="col-sm-8">
                  <mes-web-manufacturing-item-select name="item"
                                                     [entityId]="masterInstruction.ItemId"
                                                     [items$]="itemService.getAll$"
                                                     (entityIdChange)="masterInstruction.ItemId = $event"/>
                </div>
              </div>
              <div class="form-group row">
                <label for="sequence" class="col-sm-4 col-form-label">{{t('Sequence')}}</label>
                <div class="col-sm-8">
                  <input name="sequence" id="sequence" type="number" class="form-control" [(ngModel)]="masterInstruction.Sequence" [readonly]="readonly">
                </div>
              </div>
              <div class="form-group row">
                <label for="code" class="col-sm-4 col-form-label">{{t('Valid from/to')}}</label>
                <div class="col-sm-8">
                  <mes-date-range-picker [fromDate]="masterInstruction.ValidFrom" [toDate]="masterInstruction.ValidTo" [hasButton]="true" [disabled]="readonly"
                                         (dateSelect)="masterInstruction.ValidFrom = $event?.From; masterInstruction.ValidTo = $event.To"/>
                </div>
              </div>
            </div>
            <div class="col-lg-6">
              <div class="form-group row">
                <label for="code" class="col-sm-4 col-form-label">{{t('Yield rate')}}</label>
                <div class="col-sm-8">
                  <input name="yield-rate" class="form-control" [decimalPlaces]="6" [readonly]="readonly" [(mesNumberInput)]="masterInstruction.YieldRate">
                </div>
              </div>
              <div class="form-group row">
                <label for="previous-process-number" class="col-sm-4 col-form-label">{{t('Operation split size max')}}</label>
                <div class="col-sm-8">
                  <input name="previous-process-number" id="previous-process-number" type="number" class="form-control" [(ngModel)]="masterInstruction.PreviousProcessNumber" [readonly]="readonly"/>
                </div>
              </div>
              <div class="form-group row">
                <label for="code" class="col-sm-4 col-form-label">{{t('Setup ratio')}}</label>
                <div class="col-sm-8">
                  <mes-web-expression-formula cssClass="form-control form-control-sm" [expression]="masterInstruction.SetupRatio" [hasExternalFormula]="false" [readonly]="readonly" name="setup-ratio"/>
                </div>
              </div>
              <div class="form-group row">
                <label for="code" class="col-sm-4 col-form-label">{{t('Production ratio')}}</label>
                <div class="col-sm-8">
                  <mes-web-expression-formula cssClass="form-control form-control-sm" [expression]="masterInstruction.ProductionRatio" [hasExternalFormula]="false" [readonly]="readonly" name="production-ratio"/>
                </div>
              </div>
              <div class="form-group row">
                <label for="code" class="col-sm-4 col-form-label">{{t('Teardown ratio')}}</label>
                <div class="col-sm-8">
                  <mes-web-expression-formula cssClass="form-control form-control-sm" [expression]="masterInstruction.TeardownRatio" [hasExternalFormula]="false" [readonly]="readonly" name="teardown-ratio"/>
                </div>
              </div>
              <div class="form-group row">
                <label for="code" class="col-sm-4 col-form-label">{{t('Valid condition')}}</label>
                <div class="col-sm-8">
                  <mes-web-expression-formula cssClass="form-control form-control-sm" [expression]="masterInstruction.ValidCondition" [hasExternalFormula]="false" [readonly]="readonly" name="valid-condition"/>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="card">
        <div class="card-body">
          <div class="card-title d-flex pb-1">
            <h5 class="d-inline-block">{{t('Specs')}}</h5>
          </div>
          <ime-spec-lines-edit [context]="masterInstruction" [readonly]="readonly"/>
        </div>
      </div>
    </form>
  </div>
</ng-container>
